import { Badge, Button, Col, Popover, Row, Select, Space, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { DownloadOutlined } from '@ant-design/icons';
import { DebouncedCompactSearch } from '../../../../shared/components/DebouncedCompactSearch/DebouncedCompactSearch';
import export_svg from '../../../../shared/svgs/export_svg';
import { commonTopFilterRow } from '../../../../utils/filters';
import { ICommonFilter } from '../../commonTypes';
import { companyType } from '../D2r';
import { v4 } from 'uuid';
import { PAYMENT_METHOD } from 'constants';
import styles from './index.module.scss';

export const searchOptions = [
	{ value: 'invoiceId', label: 'Invoice Id' },
	{ value: 'creditNoteId', label: 'Credit Note Id' },
	{ value: 'retailer', label: 'Retailer Name' },
	{ value: 'cnstatus', label: 'Credit Note Status' }
];

export const defaultFilter: ICommonFilter = {
	start: dayjs().subtract(30, 'day'),
	end: dayjs(),
	searchOptionType: searchOptions[0].value
};

export enum ICreditNoteStatus {
	GENERATED = 'GENERATED',
	APPROVED = 'APPROVED',
	PICKED_UP = 'PICKED_UP'
}

export const creditNoteCode = {
	GENERATED: '001',
	PICKED_UP: '002',
	APPROVED: '003'
};
export interface IFilter extends ICommonFilter {
	status?: number;
	company?: companyType;
}

export function topFilterUtil({
	filter,
	setFilter,
	setPageConfigDefault,
	selectedRowKeys,
	onCSVDownload,
	onDownloadCreditVoucherXml,
	onDownloadCreditVoucherExcel,
	isVoucherXmlLoading,
	isVoucherExcelLoading
}: any): any {
	const setDate = (startDate: string, endDate: string) => {
		setPageConfigDefault();
		setFilter((prevFilter: IFilter) => ({
			...prevFilter,
			start: startDate,
			end: endDate
		}));
	};

	const handleCredtNoteStatusChange = (creditNoteStatus: string) => {
		setPageConfigDefault();
		setFilter((prevFilter: IFilter) => ({ ...prevFilter, creditNoteStatus }));
		console.log(filter);
	};
	const topFilterRow = commonTopFilterRow(filter.start, filter.end);

	return {
		row1: [
			{
				...topFilterRow,
				onChange: (dateStrings: [string, string]) => setDate(...dateStrings)
			}
		],
		row1children: [
			<div key={1}>
				<DebouncedCompactSearch
					defaultSearchOptionType={filter.searchOptionType}
					searchOptions={searchOptions}
					setFilter={setFilter}
					setDefault={setPageConfigDefault}
					selectStyle={{ minWidth: '150px' }}
				>
					<span>Search By:</span>
				</DebouncedCompactSearch>
			</div>,
			<div key={1}>
				{selectedRowKeys.length !== 0 && (
					<Badge size="default" count={`${selectedRowKeys.length} selected`} style={{ backgroundColor: '#6c757d' }} />
				)}
			</div>,
			<div key={v4()} className={styles.creditNoteStatusFilter}>
				<span>Credit Note Status:</span>
				<Select
					placeholder="Select Credit note status"
					value={filter.paymentMethod}
					defaultValue={filter.creditNoteStatus}
					onChange={handleCredtNoteStatusChange}
					allowClear={true}
				>
					{Object.keys(ICreditNoteStatus).map((creditstatus) => {
						return <Select.Option key={creditstatus}>{creditstatus}</Select.Option>;
					})}
				</Select>
			</div>
		],
		row2: [
			<Row key={2}>
				<Col>
					<Tooltip placement="left" title={'Export details for all orders'}>
						<Button style={{ marginTop: '1.5rem', marginRight: '0.5rem' }} onClick={onCSVDownload}>
							<span>{export_svg}</span>
							<span style={{ marginLeft: '.4rem', fontSize: '0.85rem' }}>Export</span>
						</Button>
					</Tooltip>
				</Col>
				<Col>
					<Popover
						style={{ maxWidth: 100 }}
						content={
							<Space direction="vertical" className={'ml-0'} key={'1'}>
								<label style={{ marginBottom: '5px', maxWidth: '350px' }}>
									{`Tally Voucher will be downloaded for ${
										selectedRowKeys.length
									} selected order${selectedRowKeys.length > 1 ? 's' : ''}.`}
								</label>

								<div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
									<Button
										type="primary"
										onClick={onDownloadCreditVoucherXml}
										style={{ marginTop: '30px' }}
										loading={isVoucherXmlLoading}
									>
										<b>XML</b>
									</Button>
									<Button
										type="primary"
										onClick={onDownloadCreditVoucherExcel}
										style={{ marginTop: '30px' }}
										loading={isVoucherExcelLoading}
									>
										<b>Excel</b>
									</Button>
								</div>
							</Space>
						}
						title="Select Format"
						trigger="click"
					>
						<Button style={{ marginTop: '1.5rem' }}>
							<span>{<DownloadOutlined />}</span>
							<span style={{ marginLeft: '.4rem', fontSize: '0.85rem' }}>Voucher</span>
						</Button>
					</Popover>
				</Col>
			</Row>
		]
	};
}
